import { z } from 'zod';

export const LookupCpfParamsSchema = z.object({
  cpf: z.string().trim().min(11),
});

export type LookupCpfParams = z.infer<typeof LookupCpfParamsSchema>;

export const LookupCpfResponseSchema = z.object({
  cpfNormalized: z.string(),
  name: z.string(),
  birthDate: z.iso.date().nullable(),
  source: z.enum(['directory', 'hubdesenvolvedor', 'apifull']),
  fetchedAt: z.iso.datetime(),
});

export type LookupCpfResponse = z.infer<typeof LookupCpfResponseSchema>;
